import { defineComponent as _defineComponent } from 'vue'
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';
import { store } from '@/store/index';
import { dispatchSetUserLocale } from '@/store/main/actionsMain';
import { useChemicanUrls } from '@/composables/useChemicanUrls';


export default /*#__PURE__*/_defineComponent({
  __name: 'LPHeaderMenuPc',
  setup(__props) {

const changeLocale = (locale: string) => {
  dispatchSetUserLocale(store, locale);
};

const m = defineMessages({
  top: 'トップ',
});

// 共通の URL 生成ロジックを使用
const { signupUrl, contactUrl, pricingUrl, featuresUrl, companyUrl } =
  useChemicanUrls();

return { __sfc: true,changeLocale, m, signupUrl, contactUrl, pricingUrl, featuresUrl, companyUrl, sharedMessages }
}

})